//"use strict";

angular
    .module("app.factories.xcenterUtils", []) // app.factories.startup-module
    // -------------------------------------------//
    //               f_Info is for Popups
    // -------------------------------------------//

    .factory("xcenterUtils", ["ENUM",
        function (ENUM) {
            var obj = {
                wasEdited: function (a, b, props) {
                    for (var i = 0; i < props.length; i++) {
                        if (a[props[i]] != b[props[i]]) {
                            return true;
                        }
                    }
                    return false;
                },
                getClasses: function (DeviceType) {
                    function searchForCss(searchClassName) {
                        for (let i = 0; i < document.styleSheets.length; i++) {
                            let styleSheet = document.styleSheets[i];
                            try {
                                for (let j = 0; j < styleSheet.cssRules.length; j++) {
                                    let rule = styleSheet.cssRules[j];
                                    // console.log(rule.selectorText)
                                    if (
                                        rule.selectorText &&
                                        rule.selectorText.includes(searchClassName)
                                    ) {
                                        //console.log('found - ', rule.selectorText, ' ', i, '-', j);
                                        return true;
                                    }
                                }
                                if (styleSheet.imports) {
                                    for (let k = 0; k < styleSheet.imports.length; k++) {
                                        let imp = styleSheet.imports[k];
                                        for (let l = 0; l < imp.cssRules.length; l++) {
                                            let rule = imp.cssRules[l];
                                            if (
                                                rule.selectorText &&
                                                rule.selectorText.includes(searchClassName)
                                            ) {
                                                //console.log('found - ',rule.selectorText,' ',i,'-',k,'-',l);
                                                return true;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {}
                        }
                        return false;
                    }

                    let icons = `dsib obj-icon`;
                    const DeviceTypesAsKeys = ENUM.getDeviceTypesByFilter('1AsKey');
                    const imageName = DeviceTypesAsKeys[ DeviceType ].Image.Name;

                    if (searchForCss(`icon-plural-${imageName}`)) {
                        icons += ` icon-plural-${imageName}`;
                    } else {
                        icons += ` icon-${imageName}`;
                    }
                    return icons;
                }
            };

            return obj;
        },
    ]);

